import { render, staticRenderFns } from "./DetailsPages.vue?vue&type=template&id=93df9650&scoped=true"
import script from "./DetailsPages.vue?vue&type=script&lang=js"
export * from "./DetailsPages.vue?vue&type=script&lang=js"
import style0 from "./DetailsPages.vue?vue&type=style&index=0&id=93df9650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df9650",
  null
  
)

export default component.exports